import { Injectable } from '@angular/core';
import { APP_URLS } from '../../../providers/constant';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class DomainHomePageService {
    constructor(http) {
        this.http = http;
        this.demoApiUrl = `${APP_URLS.DEMO_API_URL}`;
    }
    purchaseBundleByUser(purchaseObject) {
        return this.http.post(`${this.demoApiUrl}/manage_apis/feed/v1/stripe_payment/stripe_session.php`, purchaseObject);
    }
}
DomainHomePageService.ɵfac = function DomainHomePageService_Factory(t) { return new (t || DomainHomePageService)(i0.ɵɵinject(i1.HttpClient)); };
DomainHomePageService.ɵprov = i0.ɵɵdefineInjectable({ token: DomainHomePageService, factory: DomainHomePageService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DomainHomePageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();
//# sourceMappingURL=domain-home-page.service.js.map